import { toast } from 'react-toastify'
import { snapshot } from 'valtio'
import { recurringPaymentProxy } from '../../../../../../../shared/proxies/recurringPaymentProxy'
import { buildAxiosInstance } from '../../../../../../../shared/utils/apiUtils'
import { convertFromCentValue } from '../../../../../../../shared/utils/formattingUtils'
import { type RpOccurrence, rpOccurrenceProxy } from '../../rpOccurrenceProxy'

interface Response {
  data: {
    rpOccurrence: RpOccurrence
  }
  error: string | null
}
export async function executeRecurringTransactionMarkAsUnresolved (): Promise<void> {
  const { rpOccurrence } = snapshot(rpOccurrenceProxy)

  if (!rpOccurrence) {
    return
  }

  recurringPaymentProxy.suspendApiCall.loading = true
  recurringPaymentProxy.suspendApiCall.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/rp_occurrences/unresolve',
      {
        rpOccurrenceId: rpOccurrence.id
      })

    if (response.data.error) {
      recurringPaymentProxy.suspendApiCall.error = response.data.error
      toast.error('There was an error marking the occurrence as unresolved')
    } else {
      const rpOccurrence = response.data?.data?.rpOccurrence ?? {}

      rpOccurrence.amountCents = convertFromCentValue(rpOccurrence.amountCents, rpOccurrence.amountCurrencyType)

      if (rpOccurrence.transactions) {
        rpOccurrence.transactions.forEach(txn => {
          txn.amountCents = convertFromCentValue(txn.amountCents, txn.amountCurrencyType)
          txn.remainingAmountCents = convertFromCentValue(txn.remainingAmountCents, txn.remainingAmountCurrencyType)
        })
      }

      rpOccurrenceProxy.rpOccurrence = rpOccurrence
      toast.success('Occurrence successfully marked as unresolved')
    }
  } catch (e) {
    if (e instanceof Error) {
      recurringPaymentProxy.suspendApiCall.error = e.message
      toast.error('There was an error marking the occurrence as unresolved')
    }
  } finally {
    recurringPaymentProxy.suspendApiCall.loading = false
    recurringPaymentProxy.nextPaymentDate = null
  }
}
